"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6284],{

/***/ 96284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





function ConsentBlock(props) {
  var _props$document, _props$document$field, _props$document2, _props$document2$fiel, _props$document2$fiel2, _props$document2$fiel3, _props$document3, _props$document3$fiel, _props$document4, _props$document4$fiel, _props$document4$fiel2, _props$document4$fiel3;

  var activateCookieConsentEU = props == null ? void 0 : (_props$document = props.document) == null ? void 0 : (_props$document$field = _props$document.fields) == null ? void 0 : _props$document$field.activateCookieConsentEU;
  var cookieConsentLabel = props == null ? void 0 : (_props$document2 = props.document) == null ? void 0 : (_props$document2$fiel = _props$document2.fields) == null ? void 0 : (_props$document2$fiel2 = _props$document2$fiel.cookieConsentLabel) == null ? void 0 : (_props$document2$fiel3 = _props$document2$fiel2.fields) == null ? void 0 : _props$document2$fiel3.text;
  var activateDoNotSellMyData = props == null ? void 0 : (_props$document3 = props.document) == null ? void 0 : (_props$document3$fiel = _props$document3.fields) == null ? void 0 : _props$document3$fiel.activateDoNotSellMyData;
  var doNotSellMyDataLabel = props == null ? void 0 : (_props$document4 = props.document) == null ? void 0 : (_props$document4$fiel = _props$document4.fields) == null ? void 0 : (_props$document4$fiel2 = _props$document4$fiel.doNotSellMyDataLabel) == null ? void 0 : (_props$document4$fiel3 = _props$document4$fiel2.fields) == null ? void 0 : _props$document4$fiel3.text;
  var config = {
    ADD_TAGS: ['button'],
    ADD_ATTR: ['onclick', 'aria-label']
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
    children: [activateCookieConsentEU && cookieConsentLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "ob-eu-cookie-consent",
      dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize("\n                <button aria-label={cookieConsentLabel} onclick=\"Optanon.ToggleInfoDisplay();\">".concat(cookieConsentLabel, "</button>\n                "), config)
      }
    }), doNotSellMyDataLabel && activateDoNotSellMyData && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
      className: "ob-us-personal-data",
      dangerouslySetInnerHTML: {
        __html: DOMPurify.sanitize("\n                        <button aria-label={doNotSellMyDataLabel} onclick=\"Optanon.ToggleInfoDisplay();\">".concat(doNotSellMyDataLabel, "</button>\n                        "), config)
      }
    })]
  });
}

/* harmony default export */ __webpack_exports__["default"] = (ConsentBlock);

/***/ })

}]);